import { RootReducerState } from '../../root.reducer';
import { ExportOfflineFormUseCaseOutput, GetOfflineExportPlanUseCaseOutput } from '@module/form';
import { RequestStatus } from '@lib/plugin-redux-core';
import { UseCaseError } from '@digibricks/core';

export const exportOfflineFormStatusSelector = (state: RootReducerState): RequestStatus =>
  state.formEdit.exportOfflineFormStatus;

export const exportOfflineFormResultSelector = (
  state: RootReducerState,
): ExportOfflineFormUseCaseOutput | null => state.formEdit.exportOfflineFormResult;

export const exportOfflineFormErrorSelector = (state: RootReducerState): UseCaseError<any> | null =>
  state.formEdit.exportOfflineFormError;

export const exportOfflineFormRequestIdSelector = (state: RootReducerState): string | null =>
  state.formEdit.exportOfflineFormRequestId;

export const getOfflineExportPlanStatusSelector = (state: RootReducerState): RequestStatus =>
  state.formEdit.getOfflineExportPlanStatus;

export const getOfflineExportPlanResultSelector = (
  state: RootReducerState,
): GetOfflineExportPlanUseCaseOutput | null => state.formEdit.getOfflineExportPlanResult;

export const getOfflineExportPlanErrorSelector = (
  state: RootReducerState,
): UseCaseError<any> | null => state.formEdit.getOfflineExportPlanError;
